export default "__VITE_ASSET__bfa8b1fe__"